import * as ReactRedux from 'react-redux';
import AdminDashboardComponent from './admin.dashboard.component';
import { AppState } from '../app/app.types';

const mapDispatchToProps = (dispatch) => {
  return {

  };
};

const mapStateToProps = (state: AppState) => {
  return {
    authState: state.authState,
    adminState: state.adminState
  };
};

const AdminDashboard = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(AdminDashboardComponent);

export default AdminDashboard;


// WEBPACK FOOTER //
// ./src/admin/admin.dashboard.tsx